export const san2FaceNames = [
  '伊籍',
  '袁熙',
  '袁紹',
  '袁尚',
  '袁術',
  '袁譚',
  '王粲',
  '王雙',
  '諸葛誕',
  '王朗',
  '蒯越',
  '蒯良',
  '華歆',
  '賈詡',
  '郭奕',
  '郭嘉',
  '郭汜',
  '郝昭',
  '郭圖',
  '夏侯威',
  '夏侯淵',
  '夏侯恩',
  '夏侯惠',
  '夏侯尚',
  '夏侯惇',
  '夏侯德',
  '夏侯霸',
  '華佗',
  '華雄',
  '關羽',
  '韓玄',
  '夏侯和',
  '關興',
  '關索',
  '韓遂',
  '韓嵩',
  '闞澤',
  '母丘儉',
  '甘寧',
  '韓馥',
  '關平',
  '郭攸之',
  '顏良',
  '姜維',
  '許靖',
  '許褚',
  '許攸',
  '紀靈',
  '金環結',
  '金旋',
  '牛金',
  '魏延',
  '鍾會',
  '虞翻',
  '邢道榮',
  '薛綜',
  '嚴顏',
  '嚴峻',
  '黃蓋',
  '黃權',
  '侯成',
  '黃祖',
  '公孫越',
  '公孫瓚',
  '黃忠',
  '高定',
  '孔融',
  '公孫淵',
  '吳懿',
  '吳蘭',
  '蔡冒',
  '沙摩可',
  '周倉',
  '周瑜',
  '諸葛恪',
  '諸葛瑾',
  '諸葛亮',
  '審配',
  '司馬懿',
  '司馬師',
  '司馬昭',
  '周泰',
  '朱桓',
  '蔣琬',
  '尚寵',
  '鍾繇',
  '辛毘',
  '荀彧',
  '荀攸',
  '徐榮',
  '徐晃',
  '徐庶',
  '文欽',
  '曹叡',
  '曹休',
  '曹洪',
  '曹昂',
  '曹彰',
  '曹植',
  '曹真',
  '曹純',
  '曹仁',
  '曹操',
  '曹丕',
  '沮授',
  '孫堅',
  '孫乾',
  '孫權',
  '孫策',
  '孫翊',
  '太史慈',
  '朵思王',
  '趙雲',
  '張紘',
  '張郃',
  '張昭',
  '張松',
  '張任',
  '趙統',
  '張飛',
  '張苞',
  '張遼',
  '張魯',
  '陳宮',
  '趙廣',
  '陳群',
  '程昱',
  '程普',
  '典韋',
  '田豐',
  '董允',
  '陶謙',
  '鄧芝',
  '董卓',
  '董余奴',
  '馬休',
  '馬謖',
  '馬超',
  '馬鐵',
  '馬騰',
  '馬良',
  '費禕',
  '糜竺',
  '鄧艾',
  '文醜',
  '文聘',
  '法正',
  '龐統',
  '龐德',
  '滿寵',
  '孟獲',
  '孟優',
  '楊修',
  '楊奉',
  '雷同',
  '劉焉',
  '劉琦',
  '劉璋',
  '劉禪',
  '劉表',
  '劉備',
  '劉曄',
  '呂布',
  '呂蒙',
  '李傕',
  '陸遜',
  '李儒',
  '魯肅',
  '劉琮',
  '劉循',
  '孫亮',
  '張衛',
  '張休',
  '陳震',
  '典滿',
  '董衡',
  '袁胤',
  '司馬徽', // NBC
  '程秉',
  '樊稠',
  '李恢',
  '凌統',
  '凌操',
  '呂霸',
  '李異',
  '呂曠',
  '逢紀',
  '龐義',
  '馬岱',
  '閻圃',
  '許子將', // NBC
  '新武將',
  '新武將',
  '新武將',
  '新武將',
  '新武將',
  '新武將',
  '新武將',
  '新武將',
  '新武將',
  '新武將', // 200
  '新武將',
  '新武將',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
  '女兒',
];

export const san3FaceNames = [
  '伊籍',
  '袁熙',
  '袁紹',
  '袁尚',
  '袁術',
  '袁譚',
  '王粲',
  '王雙',
  '諸葛誕',
  '王朗',
  '蒯越',
  '蒯良',
  '華歆',
  '賈詡',
  '郭奕',
  '郭嘉',
  '郭汜',
  '郝昭',
  '郭圖',
  '夏侯威',
  '夏侯淵',
  '夏侯恩',
  '夏侯惠',
  '夏侯尚',
  '夏侯惇',
  '夏侯德',
  '夏侯霸',
  '華佗', // NBC (not check name in game yet)
  '華雄',
  '關羽',
  '韓玄',
  '夏侯和',
  '關興',
  '關索',
  '韓遂',
  '韓嵩',
  '闞澤',
  '毌丘儉',
  '甘寧',
  '韓馥',
  '關平',
  '郭攸之',
  '顏良',
  '姜維',
  '許靖',
  '許褚',
  '許攸',
  '紀靈',
  '金環結',
  '金旋',
  '牛金',
  '魏延',
  '鍾會',
  '虞翻',
  '邢道榮',
  '薛綜',
  '嚴顏',
  '嚴畯',
  '黃蓋',
  '黃權',
  '侯成',
  '黃祖',
  '公孫越',
  '公孫瓚',
  '黃忠',
  '孫瑜',
  '孔融',
  '公孫淵',
  '吳懿',
  '吳蘭',
  '蔡瑁',
  '沙摩柯',
  '周倉',
  '周瑜',
  '諸葛恪',
  '諸葛瑾',
  '諸葛亮',
  '審配',
  '司馬懿',
  '司馬師',
  '司馬昭',
  '周泰',
  '朱桓',
  '蔣琬',
  '向寵',
  '鍾繇',
  '辛毗',
  '荀彧',
  '荀攸',
  '徐榮',
  '徐晃',
  '徐庶',
  '文欽',
  '曹叡',
  '曹休',
  '曹洪',
  '曹昂',
  '曹彰',
  '曹植',
  '曹真',
  '曹純',
  '曹仁',
  '曹操',
  '曹丕',
  '沮授',
  '孫堅',
  '孫乾',
  '孫權',
  '孫策',
  '孫翊',
  '太史慈',
  '朵思王',
  '趙雲',
  '張紘',
  '張郃',
  '張昭',
  '張松',
  '張任',
  '趙統',
  '張飛',
  '張苞',
  '張遼',
  '張魯',
  '陳宮',
  '趙廣',
  '陳群',
  '程昱',
  '程普',
  '典韋',
  '田豐',
  '董允',
  '陶謙',
  '鄧芝',
  '董卓',
  '董荼那',
  '馬休',
  '馬謖',
  '馬超',
  '馬鐵',
  '馬騰',
  '馬良',
  '費禕',
  '糜竺',
  '鄧艾',
  '文醜',
  '文聘',
  '法正',
  '龐統',
  '龐德',
  '滿寵',
  '孟獲',
  '孟優',
  '楊脩',
  '楊奉',
  '雷銅',
  '劉焉',
  '劉琦',
  '劉璋',
  '劉禪',
  '劉表',
  '劉備',
  '劉曄',
  '呂布',
  '呂蒙',
  '李傕',
  '陸遜',
  '李儒',
  '魯肅',
  '劉琮',
  '劉循',
  '淳于瓊',
  '張衛',
  '張休',
  '陳震',
  '徐盛',
  '董衡',
  '袁胤',
  '司馬徽', // NBC (not check name in game yet)
  '高覽',
  '樊稠',
  '李恢',
  '凌統',
  '凌操',
  '蔣義渠',
  '李異',
  '呂曠',
  '逢紀',
  '郭淮',
  '馬岱',
  '閻圃',
  '許子將', // NBC
  '橋瑁',
  '孔伷',
  '劉繇',
  '嚴白虎',
  '樂進',
  '于禁',
  '賈逵',
  '王甫',
  '王允',
  '吳班',
  '顧雍',
  '蔣欽',
  '辛評',
  '孫禮',
  '張嶷',
  '張繡',
  '陳泰',
  '陳登',
  '丁奉',
  '馬忠',
  '孟達',
  '楊儀',
  '李嚴',
  '李典',
  '劉封',
  '廖化',
  '呂凱',
  '簡雍',
  '譚雄',
  '王平',
  '韓當',
  '糜芳',
  '獻帝', // NBC (not check name in game yet)
  '吉平', // NBC (not check name in game yet)
  '于吉', // NBC (not check name in game yet)
  '左慈', // NBC
  '管輅', // NBC (not check name in game yet)
  '紫虛上人', // NBC (not check name in game yet)
  '李意', // NBC (not check name in game yet)
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主女',
  '新君主女',
  '新君主女',
  '新君主女',
  '新君主女',
  '新君主女',
  '新君主女',
  '新君主女',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '貂蟬',
];

export const san4FaceNames = [
  '張飛',
  '關羽',
  '呂布',
  '馬超',
  '袁紹',
  '夏侯淵',
  '夏侯惇',
  '華雄',
  '趙雲',
  '顏良',
  '文醜',
  '許褚',
  '典韋',
  '張遼',
  '魏延',
  '嚴顏',
  '甘寧',
  '關平',
  '黃蓋',
  '周倉',
  '曹彰',
  '太史慈',
  '黃忠',
  '曹仁',
  '張郃',
  '馬岱',
  '馬騰',
  '龐德',
  '孟獲',
  '呂蒙',
  '伊籍',
  '袁術',
  '袁熙',
  '袁尚',
  '袁譚',
  '劉備',
  '徐晃',
  '公孫瓚',
  '徐庶',
  '蒯越',
  '蒯良',
  '賈詡',
  '郭嘉',
  '荀彧',
  '諸葛亮',
  '諸葛瑾',
  '曹洪',
  '曹植',
  '司馬懿',
  '張松',
  '王朗',
  '韓玄',
  '韓馥',
  '喬瑁',
  '金旋',
  '嚴白虎',
  '孔秀',
  '孔融',
  '曹叡',
  '曹操',
  '曹丕',
  '孫堅',
  '孫策',
  '孫權',
  '趙範',
  '張魯',
  '陶謙',
  '董卓',
  '李傕',
  '劉焉',
  '劉璋',
  '劉禪',
  '劉度',
  '劉表',
  '劉繇',
  '于禁',
  '郝昭',
  '樂進',
  '郭圖',
  '夏侯霸',
  '關興',
  '關索',
  '韓遂',
  '姜維',
  '吳懿',
  '公孫淵',
  '蔡瑁',
  '司馬師',
  '司馬昭',
  '周泰',
  '周瑜',
  '蔣琬',
  '鍾會',
  '諸葛恪',
  '諸葛誕',
  '審配',
  '曹休',
  '曹真',
  '曹爽',
  '沮授',
  '張紘',
  '張昭',
  '張苞',
  '陳宮',
  '陳群',
  '程昱',
  '田豐',
  '馬謖',
  '馬良',
  '費禕',
  '文聘',
  '逢紀',
  '法正',
  '龐統',
  '孟達',
  '楊修',
  '陸遜',
  '李嚴',
  '李儒',
  '劉琦',
  '廖化',
  '凌統',
  '魯肅',
  '朱桓',
  '徐盛',
  '鄧艾',
  '阿會喃',
  '越吉',
  '俄何燒戈',
  '雅丹',
  '軻比能',
  '金環三結',
  '奚泥',
  '兀突骨',
  '左賢王',
  '沙摩柯',
  '祝融夫人',
  '帶來洞主',
  '朵思大王',
  '徹里吉',
  '土安',
  '董荼那',
  '蹋頓',
  '忙牙長',
  '木鹿大王',
  '迷當大王',
  '孟優',
  '楊鋒',
  '陸抗',
  '王濬',
  '王粲',
  '王平',
  '韓當',
  '牛金',
  '紀靈',
  '黃權',
  '荀攸',
  '辛評',
  '孫乾',
  '張繡',
  '程普',
  '糜竺',
  '糜芳',
  '董允',
  '文鴦',
  '滿寵',
  '李典',
  '劉曄',
  '袁胤',
  '閻圃',
  '王允',
  '毌丘儉',
  '闞澤',
  '簡雍',
  '劉循',
  '許靖',
  '許攸',
  '虞翻',
  '黃祖',
  '吳班',
  '顧雍',
  '吳蘭',
  '孫異',
  '向寵',
  '諸葛瞻',
  '辛毗',
  '曹昂',
  '孫休',
  '丁奉',
  '鄧芝',
  '杜預',
  '羊祜',
  '劉琮',
  '劉封',
  '華歆',
  '賈逵',
  '郤正',
  '鍾繇',
  '陳泰',
  '盧植',
  '皇甫嵩',
  '張翼',
  '李恢',
  '王基',
  '王雙',
  '郭淮',
  '夏侯尚',
  '胡奮',
  '司馬炎',
  '孫冀',
  '于詮',
  '蔣欽',
  '張悌',
  '孫桓',
  '孫翊',
  '孫亮',
  '張嶷',
  '張任',
  '趙統',
  '陳登',
  '陳武',
  '董襲',
  '馬忠',
  '潘璋',
  '文欽',
  '步騭',
  '楊儀',
  '雷銅',
  '李異',
  '譚雄',
  '滕胤',
  '呂凱',
  '呂範',
  '呂曠',
  '賈充',
  '郭汜',
  '邢道榮',
  '夏侯威',
  '高覽',
  '胡遵',
  '趙廣',
  '陳震',
  '尹默',
  '王累',
  '夏侯和',
  '夏侯惠',
  '夏侯玄',
  '郭攸之',
  '全琮',
  '韓嵩', // 250 (1-base)
  '華佗', // NBC
  '管輅',
  '司馬徽',
  '許子將',
  '于吉',
  '左慈',
  '馬鈞',
  '普淨', // NBC
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主男',
  '新君主女',
  '新君主女',
  '新君主女',
  '新君主女',
  '新君主女',
  '新君主女',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '',
  '',
  '',
  '密探',
  '士兵',
  '書僮',
  '',
  '',
  '貂蟬',
  '獻帝',
];

export const san5FaceNames = [
  '張飛', // 0, 0x00
  '關羽',
  '呂布',
  '馬超',
  '袁紹',
  '夏侯淵',
  '夏侯惇',
  '華雄',
  '趙雲',
  '顏良',
  '文醜',
  '許褚',
  '典韋',
  '張遼',
  '魏延',
  '嚴顏',
  '甘寧', // 16, 0x10
  '關平',
  '黃蓋',
  '周倉',
  '曹彰',
  '太史慈',
  '黃忠',
  '曹仁',
  '張郃',
  '馬岱',
  '馬騰',
  '龐德',
  '孟獲',
  '呂蒙',
  '伊籍',
  '袁術',
  '袁熙', // 32, 0x20
  '袁尚',
  '袁譚',
  '劉備',
  '徐晃',
  '公孫瓚',
  '徐庶',
  '蒯越',
  '蒯良',
  '賈詡',
  '郭嘉',
  '荀彧',
  '諸葛亮',
  '諸葛瑾',
  '曹洪',
  '曹植',
  '司馬懿', // 48, 0x30
  '張松',
  '王朗',
  '韓玄',
  '韓馥',
  '喬瑁',
  '金旋',
  '嚴白虎',
  '孔岫',
  '孔融',
  '曹叡',
  '曹操',
  '曹丕',
  '孫堅',
  '孫策',
  '孫權',
  '趙範', // 64, 0x40
  '張魯',
  '陶謙',
  '董卓',
  '李傕',
  '劉焉',
  '劉璋',
  '劉禪',
  '劉度',
  '劉表',
  '劉繇',
  '于禁',
  '郝昭',
  '樂進',
  '郭圖',
  '夏侯霸',
  '關興', // 80, 0x50
  '關索',
  '韓遂',
  '姜維',
  '吳懿',
  '公孫淵',
  '蔡瑁',
  '司馬師',
  '司馬昭',
  '周泰',
  '周瑜',
  '蔣琬',
  '鍾會',
  '諸葛恪',
  '諸葛誕',
  '審配',
  '曹休', // 96, 0x60
  '曹真',
  '曹爽',
  '沮授',
  '張紘',
  '張昭',
  '張苞',
  '陳宮',
  '陳群',
  '程昱',
  '田豐',
  '馬謖',
  '馬良',
  '費禕',
  '文聘',
  '逢紀',
  '法正', // 112, 0x70
  '龐統',
  '孟達',
  '楊修',
  '陸遜',
  '李嚴',
  '李儒',
  '劉琦',
  '廖化',
  '凌統',
  '魯肅',
  '朱桓',
  '徐盛',
  '鄧艾',
  '阿會喃',
  '越吉',
  '俄何燒戈', // 128, 0x80
  '雅丹',
  '軻比能',
  '金環三結',
  '奚泥',
  '兀突骨',
  '左賢王',
  '沙摩柯',
  '祝融夫人',
  '帶來洞主',
  '朵思大王',
  '徹里吉',
  '土安',
  '董荼那',
  '蹋頓',
  '忙牙長',
  '木鹿大王', // 144, 0x90
  '迷當大王',
  '孟優',
  '楊鋒',
  '陸抗',
  '王濬',
  '王粲',
  '王平',
  '韓當',
  '牛金',
  '紀靈',
  '黃權',
  '荀攸',
  '辛評',
  '孫乾',
  '張繡',
  '程普', // 160, 0xA0
  '糜竺',
  '糜芳',
  '董允',
  '文鴦',
  '滿寵',
  '李典',
  '劉瞱',
  '袁胤',
  '閻圃',
  '王允',
  '毌丘儉',
  '闞澤',
  '簡雍',
  '劉循',
  '許靖',
  '許攸', // 176, 0xB0
  '虞翻',
  '黃祖',
  '吳班',
  '顧雍',
  '吳蘭',
  '孫異',
  '向寵',
  '諸葛瞻',
  '辛毗',
  '曹昂',
  '孫休',
  '丁奉',
  '鄧芝',
  '杜預',
  '羊祜',
  '劉琮', // 192, 0xC0
  '劉封',
  '華歆',
  '賈逵',
  '郤正',
  '鍾繇',
  '陳泰',
  '盧植',
  '皇甫嵩',
  '張翼',
  '李恢',
  '王基',
  '王雙',
  '郭淮',
  '夏侯尚',
  '胡奮',
  '司馬炎', // 208, 0xD0
  '孫冀',
  '于詮',
  '蔣欽',
  '張悌',
  '孫桓',
  '孫翊',
  '孫亮',
  '張嶷',
  '張任',
  '趙統',
  '陳登',
  '陳武',
  '董襲',
  '馬忠',
  '潘璋',
  '文欽', // 224, 0xE0
  '步騭',
  '楊儀',
  '雷銅',
  '李異',
  '譚雄',
  '滕胤',
  '呂凱',
  '呂範',
  '呂曠',
  '賈充',
  '郭汜',
  '邢道榮',
  '夏侯威',
  '高覽',
  '胡遵',
  '趙廣', // 240, 0xF0
  '陳震',
  '尹默',
  '王累',
  '夏侯和',
  '夏侯惠',
  '夏侯玄',
  '郭攸之',
  '全琮',
  '韓嵩',
  '張角',
  '張寶',
  '張梁',
  '程遠志',
  '管亥',
  '龔都',
  '劉辟', // 256, 0x100
  '裴元紹',
  '何進',
  '鄒靖',
  '毛玠',
  '臧霸',
  '陳矯',
  '董昭',
  '公孫度',
  '徐榮',
  '李肅',
  '朱雋',
  '高順',
  '張邈',
  '譙周',
  '黃皓',
  '孫皓', // 272, 0x110
  '張休',
  '曹熊',
  '曹芳',
  '曹髦',
  '曹奐',
  '夏侯楙',
  '司馬攸',
  '蔡邕',
  '曹豹',
  '劉諶',
  '劉永',
  '劉理',
  '諸葛尚',
  '孫登',
  '孫和',
  '陸凱', // 288, 0x120
  '岑昏',
  '張允',
  '凌操',
  '胡車兒',
  '淳于瓊',
  '丁原',
  '陳壽',
  '禰衡',
  '喬玄',
  '諸葛均',
  '陳珪',
  '尹賞',
  '尹大目',
  '閻宇',
  '王頎',
  '王經', // 304, 0x130
  '王伉',
  '王渾',
  '王修',
  '王子服',
  '王真',
  '王戎',
  '王昶',
  '王甫',
  '華覈',
  '何儀',
  '郭奕',
  '霍峻',
  '霍弋',
  '夏侯恩',
  '夏侯德',
  '賈範', // 320, 0x140
  '關彞',
  '韓浩',
  '韓暹',
  '韓忠',
  '桓範',
  '樂綝',
  '龔景',
  '鞏志',
  '許儀',
  '魏續',
  '牽弘',
  '嚴綱',
  '嚴畯',
  '嚴政',
  '嚴輿',
  '高幹', // 336, 0x150
  '耿紀',
  '高翔',
  '高昇',
  '侯成',
  '公孫越',
  '公孫康',
  '公孫恭',
  '高定',
  '高沛',
  '胡班',
  '胡烈',
  '吾彥',
  '吳綱',
  '吳質',
  '蔡和',
  '蔡中', // 352, 0x160
  '笮融',
  '謝旌',
  '車冑',
  '朱異',
  '周昕',
  '周旨',
  '州泰',
  '周魴',
  '朱然',
  '朱治',
  '朱靈',
  '蔣幹',
  '蔣義渠',
  '蔣濟',
  '蔣舒',
  '向朗', // 368, 0x170
  '諸葛靚',
  '師纂',
  '司馬孚',
  '司馬望',
  '司馬朗',
  '沈瑩',
  '申耽',
  '秦宓',
  '徐質',
  '成宜',
  '薛瑩',
  '薛綜',
  '全禕',
  '全懌',
  '全端',
  '曹宇', // 384, 0x180
  '曹羲',
  '曹訓',
  '宋憲',
  '曹純',
  '曹性',
  '沮鵠',
  '蘇飛',
  '祖茂',
  '孫匡',
  '孫歆',
  '孫峻',
  '孫秀',
  '孫韶',
  '孫靜',
  '孫仲',
  '孫綝', // 400, 0x190
  '孫瑜',
  '孫禮',
  '孫朗',
  '卓膺',
  '張衛',
  '張燕',
  '張英',
  '張橫',
  '張溫',
  '張華',
  '張闓',
  '張勳',
  '張虎',
  '趙弘',
  '張濟',
  '張象', // 416, 0x1A0
  '張紹',
  '張節',
  '張達',
  '張布',
  '趙累',
  '陳橫',
  '陳騫',
  '陳式',
  '陳琳',
  '程銀',
  '程武',
  '程秉',
  '田續',
  '田疇',
  '党均',
  '董厥', // 432, 0x1B0
  '鄧賢',
  '董衡',
  '唐咨',
  '陶濬',
  '董承',
  '鄧忠',
  '董旻',
  '鄧茂',
  '董和',
  '杜遠',
  '裴秀',
  '范疆',
  '樊建',
  '潘濬',
  '樊稠',
  '潘鳳', // 448, 0x1C0
  '馬玩',
  '馬休',
  '馬遵',
  '馬忠',
  '馬鐵',
  '馬邈',
  '萬彧',
  '卑衍',
  '費詩',
  '馮習',
  '傅嬰',
  '傅幹',
  '傅士仁',
  '傅僉',
  '傅巽',
  '傅彤', // 464, 0x1D0
  '武安國',
  '卞喜',
  '龐義',
  '鮑隆',
  '濮陽興',
  '楊懷',
  '雍闓',
  '楊濟',
  '楊秋',
  '楊松',
  '楊祚',
  '楊彪',
  '雷薄',
  '駱統',
  '劉賢',
  '劉岱', // 480, 0x1E0
  '劉巴',
  '留略',
  '呂威璜',
  '梁興',
  '呂義',
  '呂虔',
  '呂翔',
  '陸績',
  '李鵬',
  '李豐',
  '倫直',
  '華佗',
  '司馬徽',
  '許子將',
  '于吉',
  '左慈', // 496, 0x1F0
  '管輅',
  '紫虛上人',
  '南華老仙',
  '獻帝', // 500, 0x1F4
  '貂蟬',
  '民眾',
  '',
  '',
  '',
  '使者',
  '士兵',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男', // 512, 0x200
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男', // 528, 0x210
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男', // 544, 0x220
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男', // 560, 0x230
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男', // 576, 0x240
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男', // 592, 0x250
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男', // 608, 0x260
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男',
  '新武將男', // 624, 0x270
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女', // 640, 0x280
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女', // 656, 0x290
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女', // 672, 0x2A0
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女', // 688, 0x2B0
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女', // 704, 0x2C0
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女', // 720, 0x2D0
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將女',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)', // 736, 0x2E0
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)', // 752, 0x2F0
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將男(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)', // 768, 0x300
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
  '新武將女(PUK)',
];

export const kohryukiFaceNames = [
  '項羽',
  '劉邦',
  '英布',
  '韓信',
  '范增',
  '章邯',
  '項莊',
  '司馬欣',
  '董翳',
  '章平',
  '趙歇',
  '陳餘',
  '張耳',
  '蕭公角',
  '田假',
  '鄭昌',
  '周殷',
  '鍾離昧',
  '夏說',
  '李左車',
  '項聲',
  '曹咎',
  '張逸',
  '武涉',
  '張良',
  '陳嬰',
  '項伯',
  '夏侯嬰',
  '蕭何',
  '周勃',
  '盧綰',
  '曹參',
  '審食其',
  '隨何',
  '周蘭',
  '陳平',
  '魏無知',
  '灌嬰',
  '紀信',
  '雍齒',
  '周苛',
  '樅公',
  '袁生',
  '鄭忠',
  '劉賈',
  '柴武',
  '楊喜',
  '呂馬童',
  '王翳',
  '楊武',
  '呂勝',
  '季布',
  '周昌',
  '叔孫通',
  '婁敬',
  '彭越',
  '孔聚',
  '陳賀',
  '楊',
  '申陽',
  '共敖',
  '張敖',
  '田榮',
  '龍且',
  '王陵',
  '貫高',
  '田橫',
  '田廣',
  '王吸',
  '薛歐',
  '任敖',
  '田既',
  '田光',
  '田吸',
  '侯公',
  '魏豹',
  '薛公',
  '丁公',
  '欒布',
  '臧荼',
  '司馬卬',
  '樊噲',
  '靳彊',
  '吳芮',
  '酈商',
  '蒯徹',
  '酈食其',
  '呂澤',
  '陸賈',
  '樓煩',
  '韓王信',
  '利幾',
  '',
  '長老',
  '',
  '',
  '虞姬',
];

export const lempeFaceNames = [
  '拿破崙（司令官）',
  '喬斯福',
  '魯西恩',
  '路易斯',
  '哲羅姆',
  '尤金',
  '塞律里埃',
  '卡爾諾',
  '伯奇爾',
  '脫利蘭',
  '蒙塞',
  '巴羅斯',
  '勒費弗爾',
  '歐吉里歐',
  '儒爾當',
  '馬塞納',
  '福契',
  '貝爾納多特',
  '維特',
  '圣西里',
  '杜邦',
  '德爾隆',
  '麥克唐納',
  '格魯希',
  '貝西埃爾',
  '莫羅',
  '木雷',
  '迪賽伊克斯',
  '莫蒂埃',
  '墨勃格',
  '史考得',
  '耐伊',
  '佛蘭特',
  '列寧斯',
  '旺達姆',
  '坎伯尼',
  '克拉蒙',
  '絮歇',
  '達夫歐',
  '布雷尼',
  '蒙特布朗',
  '莫羅',
  '朱諾',
  '拉普',
  '雷尼埃',
  '塞巴斯蒂尼',
  '布代',
  '馬蒙',
  '吉納德',
  '拉薩爾',
  '雷耶',
  '科蘭寇特',
  '格魯希',
  '穆頓',
  '拉貝都爾',
  '馬迪諾',
  '都布勞司基',
  '波奈塔司基',
  '喬治三世',
  '喬治四世',
  '維多利亞',
  '亞丁頓',
  '薛里登',
  '彼克頓',
  '皮特',
  '巴紹特',
  '比藍特',
  '戈登',
  '奧蘭治',
  '穆爾',
  '厄克司喬',
  '藍伯特',
  '畢瑞福德',
  '威靈頓',
  '梅特蘭',
  '康瓦利斯',
  '華亭',
  '菲利比克斯',
  '范德魯',
  '威維恩',
  '塞納爾蒙',
  '西爾',
  '波謝',
  '潘森彼',
  '麥克唐納',
  '科伯恩',
  '卡西勒布',
  '昂吉迪',
  '馬什',
  '多朗什',
  '拉姆齊',
  '查塔姆',
  '諾莫爾',
  '貝林格',
  '多爾蓀',
  '鮑威爾一世',
  '亞厲山大一世',
  '本尼格森',
  '羅斯托普金',
  '庫突斯歐夫',
  '霍夫頓',
  '普拉托夫',
  '葉爾莫洛夫',
  '戈雷謝可夫',
  '布霍布登',
  '巴克萊',
  '列弗茨基',
  '洛巴諾夫',
  '庫泰卓夫',
  '巴格拉吉昂',
  '柯羅夫',
  '德克特羅夫',
  '奇恰可夫',
  '克萊茲',
  '維特根施泰因',
  '托爾斯泰',
  '凱敏斯基',
  '圖柴可夫',
  '米洛拉多維奇',
  '尼維洛斯基',
  '哥利欣',
  '西奧斯',
  '托馬索夫',
  '康斯坦丁',
  '巴拉肖夫',
  '威廉三世',
  '布朗史威克',
  '布魯爾',
  '霍恩洛厄',
  '哈頓堡',
  '威瑪',
  '呂歇爾',
  '約克',
  '沙安赫司特',
  '普羅',
  '斯泰恩',
  '格奈森諾',
  '博恩',
  '克萊斯特',
  '芮騰',
  '弗里德瑞奇',
  '魯德維格',
  '希爾曼',
  '奧古斯特',
  '席勒',
  '克勞塞維茨',
  '科蘇泰司基',
  '法蘭一世',
  '維爾姆澤',
  '阿爾文齊',
  '歐圖一世',
  '雷伯特',
  '麥克',
  '可班瑟',
  '維恩芳',
  '貝利加德',
  '尤根',
  '費迪南',
  '施米圖',
  '米拉斯',
  '博利厄',
  '路易斯',
  '魏尼克',
  '查理斯',
  '施瓦岑貝格',
  '儒瑾',
  '米特尼奇',
  '約翰',
  '碧利歐',
  '魯西萊',
  '沙伯龍尼',
  '基瑞邁迪',
  '葛萊尼',
  '奈利',
  '羅多維可',
  '珂里',
  '威廉',
  '邦哈美',
  '荷根多',
  '詹森',
  '坎培爾',
  '柯羅華特',
  '麥克西米蘭',
  '貝利加德',
  '科魯華特',
  '波那契',
  '蒙吉拉斯',
  '夏斯',
  '瑞凡',
  '薛林三世',
  '馬斯塔法四世',
  '默函特二世',
  '怕司凡諾格魯',
  '阿部都',
  '艾普西蘭特',
  '福洛西特',
  '瑞蓋司',
  '易卜拉欣',
  '佛吉爾',
  '伊匹希莫司',
  '蒂普連',
  '穆拉德',
  '阿里',
  '卡巴庫爾',
  '恰瑞比',
  '拜拉克達',
  '卡拉喬琪',
  '泰亞爾',
  '塞蘭諾維奇',
  '卡洛司',
  '費迪南',
  '戴茲',
  '伊凡塔多',
  '庫斯塔',
  '布萊克',
  '伯雷德',
  '艾布奎克',
  '卡斯塔那司',
  '戈第',
  '達伊斯',
  '阿瑞查戈',
  '羅馬納',
  '寇爾',
  '拉丁哥',
  '米納',
  '彼可奈',
  '佐奧六世',
  '葛拉漢',
  '甫傑茲',
  '桑吉斯',
  '曼寧',
  '卡沙諾娃',
  '巴塔里亞',
  '寇尼里',
  '丹都羅',
  '比沙洛',
  '卡洛琳娜',
  '卡拉西歐羅',
  '魯索',
  '艾克頓',
  '庫寇',
  '庫利塔',
  '凡莫敦',
  '高斯塔夫四世',
  '卡爾十三世',
  '菲爾森',
  '克利斯汀七世',
  '佛瑞德雷克',
  '伯恩斯多佛',
  '詹森',
  '伯恩赫德',
  '史威恩',
  '伊納克',
  '海格',
  '克利斯坦',
  '拿破崙（第一執政）',
  '拿破崙（皇帝）',
  '約瑟芬',
  '路易莎',
  '納爾遜',
];

export const suikodenFaceNames = [
  '宋江',
  '盧俊義',
  '吳用',
  '公孫勝',
  '關勝',
  '林沖',
  '秦明',
  '呼延灼',
  '花榮',
  '柴進',
  '李應',
  '朱同',
  '魯智深',
  '武松',
  '董平',
  '張清',
  '楊志',
  '徐寧',
  '索超',
  '戴宗',
  '劉唐',
  '李逵',
  '史進',
  '穆弘',
  '雷橫',
  '李俊',
  '阮小二',
  '張橫',
  '阮小五',
  '張順',
  '阮小七',
  '楊雄',
  '石秀',
  '解珍',
  '解寶',
  '燕青',
  '朱武',
  '黃信',
  '宣贊',
  '裴宣',
  '鄧飛',
  '燕順',
  '楊林',
  '皇甫端',
  '王英',
  '扈三娘',
  '樊瑞',
  '孟康',
  '鄭天壽',
  '龔旺',
  '丁得孫',
  '宋萬',
  '杜遷',
  '薛永',
  '李忠',
  '湯窿',
  '杜興',
  '朱貴',
  '蔡福',
  '蔡慶',
  '李云',
  '顧大嫂',
  '孫二娘',
  '石遷',
  '段景住',
  '孫立',
  '單廷珪',
  '魏定國',
  '蕭讓',
  '呂方',
  '郭盛',
  '安道全',
  '孔明',
  '孔亮',
  '金大堅',
  '侯健',
  '樂和',
  '鄒淵',
  '石勇',
  '郁保四',
  '袁朗',
  '王煥',
  '王慶',
  '王進',
  '王倫',
  '丘岳',
  '喬冽',
  '許貫忠',
  '瓊英',
  '高俅',
  '寇威',
  '高廉',
  '扈成',
  '蔡京',
  '崔道成',
  '宿元景',
  '祝龍',
  '蕭嘉穗',
  '蔣忠',
  '史文恭',
  '任原',
  '西門慶',
  '石寶',
  '曾塗',
  '段三娘',
  '晁蓋',
  '張叔夜',
  '張文遠',
  '田虎',
  '鄧元覺',
  '童貫',
  '裴如海',
  '白秀英',
  '潘金蓮',
  '潘巧雲',
  '馬靈',
  '費保',
  '武大',
  '聞煥章',
  '卞祥',
  '方杰',
  '包道乙',
  '龐萬春',
  '方腊',
  '楊戩',
  '羅真人',
  '欒廷玉',
  '李鬼',
  '李師師',
  '李瑞蘭',
  '郝思文',
  '韓滔',
  '彭汜',
  '歐鵬',
  '凌振',
  '蔣敬',
  '鮑旭',
  '項充',
  '李袞',
  '馬麟',
  '童威',
  '童猛',
  '陳達',
  '楊春',
  '陶宗旺',
  '宋清',
  '穆春',
  '曹正',
  '施恩',
  '周通',
  '鄒潤',
  '朱富',
  '李立',
  '焦挺',
  '孫新',
  '張青',
  '王定六',
  '白勝',
  '葉清',
  '祝彪',
  '諸享',
  '方瓊',
  '呂師囊',
  '孫安',
  '鈕文忠',
  '張開',
  '胡顯',
  '李達',
  '蔡得章',
  '胡俊',
  '杜微',
  '黃安',
  '山士奇',
  '周謹',
  '上青',
  '白欽',
  '諸能',
  '仲良',
  '薛燦',
  '曾魁',
  '韓存保',
  '聞達',
  '曾昇',
  '蘇定',
  '黃文譁',
  '董澄',
  '家余慶',
  '范全',
  '時文彬',
  '曾索',
  '元興',
  '縻勝',
  '錢振鵬',
  '伍應星',
  '田彪',
  '苟正',
  '吳值',
  '何玄通',
  '唐斌',
  '史定',
  '王寅',
  '田豹',
  '季三思',
  '黨士英',
  '孔賓',
  '牛邦喜',
  '劉夢龍',
  '鄭之端',
  '張翔',
  '沈壽',
  '徐方',
  '曾密',
  '鄔福',
  '蔡澤',
  '項元鎮',
  '賀吉',
  '黨士雄',
  '盛本',
  '劉敏',
  '郭世廣',
  '張威',
  '于玉麟',
  '魚得源',
  '方貌',
  '鄔梨',
  '王義',
  '葉春',
  '耿恭',
  '何濤',
  '成貴',
  '程勝祖',
  '浦文英',
  '冷恭',
  '張世開',
  '雲宗武',
  '張蒙方',
  '安士榮',
  '梁士傑',
  '房學度',
  '溫克讓',
  '祝虎',
  '李懷',
  '文仲容',
  '衛忠',
  '方天定',
  '余深',
  '李吉',
  '丘小乙',
  '馬萬里',
  '何清',
  '黃文炳',
  '張保',
  '鄧龍',
  '劉高',
  '毛仲義',
  '造船所',
  '雜貨店',
  '兵工廠',
  '徽宗皇帝',
  '太宗',
];
